import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slices/user.slice";
import appSlice from "./slices/app.slice";
import sessionSlice from "./slices/session.slice";

export const store = configureStore({
	reducer: {
		user: userSlice,
		app: appSlice,
		session: sessionSlice,
	},
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
